import type { Message } from '@/types';
import type { ProcessedAttachment } from '@/utils/attachmentProcessor';

export interface MessageState {
  messages: Message[];
  isTyping: boolean;
}

export type MessageAction =
  | { type: 'ADD_USER_MESSAGE'; payload: Message }
  | { type: 'ADD_AI_MESSAGE'; payload: Message }
  | { type: 'LOAD_HISTORICAL_USER_MESSAGE'; payload: Message }
  | { type: 'LOAD_HISTORICAL_AI_MESSAGE'; payload: Message }
  | { type: 'PREPEND_HISTORICAL_MESSAGES'; payload: Message[] }
  | { type: 'SET_TYPING'; payload: boolean }
  | { type: 'UPDATE_MESSAGE_ATTACHMENTS'; payload: { 
      messageId: string; 
      imageBlobs: Blob[]; 
      imageUrls: string[];
      allAttachments?: ProcessedAttachment[];
    } }
  | { type: 'CLEAR_MESSAGES' };

export function messageReducer(state: MessageState, action: MessageAction): MessageState {
  switch (action.type) {
    case 'ADD_USER_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload],
        isTyping: true,
      };

    case 'ADD_AI_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, action.payload],
        isTyping: false,
      };

    case 'LOAD_HISTORICAL_USER_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, { ...action.payload, role: 'user' }],
        // Don't change typing state for historical messages
      };

    case 'LOAD_HISTORICAL_AI_MESSAGE':
      return {
        ...state,
        messages: [...state.messages, { ...action.payload, role: 'assistant' }],
        // Don't change typing state for historical messages
      };

    case 'PREPEND_HISTORICAL_MESSAGES':
      return {
        ...state,
        messages: [...action.payload, ...state.messages],
      };

    case 'SET_TYPING':
      return {
        ...state,
        isTyping: action.payload,
      };

    case 'UPDATE_MESSAGE_ATTACHMENTS':
      return {
        ...state,
        messages: state.messages.map(msg =>
          msg.id === action.payload.messageId
            ? {
                ...msg,
                imageBlobs: action.payload.imageBlobs,
                imageUrls: action.payload.imageUrls,
                allAttachments: action.payload.allAttachments
              }
            : msg
        ),
      };

    case 'CLEAR_MESSAGES':
      return {
        messages: [],
        isTyping: false,
      };

    default:
      return state;
  }
}
